import type React from 'react';
import { useTranslation } from 'react-i18next';
import { SearchField, Typography } from '@heroui/react';

type CategorySearchFieldProps = {
    /** How many categories the search matches; `null` while nothing is typed. */
    matchCount: number | null;
};

/**
 * The category picker's search box (design board **CategorySearch**). While
 * something is typed it shows how many categories match, as the box's
 * description, so the count is read out with it.
 */
export const CategorySearchField: React.FC<CategorySearchFieldProps> = ({
    matchCount,
}) => {
    const { t } = useTranslation('pages');
    const label = t('products.components.productTable.filters.categorySearch');

    return (
        <SearchField
            aria-label={label}
            autoFocus
            name="product-filters-category-search"
            variant="secondary"
        >
            <SearchField.Group>
                <SearchField.SearchIcon />
                <SearchField.Input placeholder={label} />
                {matchCount === null ? null : (
                    <Typography
                        className="shrink-0"
                        color="muted"
                        slot="description"
                        type="body-xs"
                    >
                        {t(
                            'products.components.productTable.filters.categoryMatches',
                            { count: matchCount },
                        )}
                    </Typography>
                )}
                <SearchField.ClearButton />
            </SearchField.Group>
        </SearchField>
    );
};
